import dynamic from 'next/dynamic';

import { H2, Paragraph } from '@collab/atoms';

import PageTitle from './PageTitle';

const H3 = dynamic(() => import('@collab/atoms/H3/H3'));
const H4 = dynamic(() => import('@collab/atoms/H4/H4'));
const H5 = dynamic(() => import('@collab/atoms/H5'));
const Li = dynamic(() => import('@collab/atoms/List/Li'));
const Ol = dynamic(() => import('@collab/atoms/List/Ol'));
const Ul = dynamic(() => import('@collab/atoms/List/Ul'));
const InlineCode = dynamic(() => import('@collab/atoms/InlineCode'));

const Details = dynamic(() => import('./accordion/Details'));
const Summary = dynamic(() => import('./accordion/Summary'));
const InlineLink = dynamic(() => import('./InlineLinkMd'));
const CodeSnippet = dynamic(() => import('./CodeSnippet'));
const Blockquote = dynamic(() => import('./Blockquote'));
const Table = dynamic(() => import('./Table'));
const Image = dynamic(() => import('./Image'));

export const mdComponents: any = {
  p: Paragraph,
  a: InlineLink,
  ul: Ul,
  li: Li,
  ol: Ol,
  code: InlineCode,
  h1: PageTitle,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  img: Image,
  inlineCode: InlineCode,
  blockquote: Blockquote,
  table: Table,
  pre: CodeSnippet,
  Details,
  Summary,
};
